export const COMMON = {
	CHOOSE_BG: "CHOOSE_BG",
}
